module.exports = function(logs) {
	'use strict'
	logs.directive('logsDir', logsDir);
	logsDir.$inject=[];
	function logsDir() {
		return {
			template: require('./partials/logsTemplate.html'),
			controller:'logsController',
			controllerAs:'vmlg',
			link: function(scope, element, attrs, ctrl) {
				
			}
		};
	};
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/logsModule/js/directive/logsDirective.js
// module id = 506
// module chunks = 0